export default "__VITE_ASSET__c9981bc1__"